/* tslint:disable */
/* eslint-disable */
/**
 * Hisselab.Hit.Query
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @enum {string}
 */

export const ActionResponseStatusEnum = {
    Ok: 'Ok',
    Error: 'Error',
    Bad: 'Bad',
    NoData: 'NoData'
} as const;

export type ActionResponseStatusEnum = typeof ActionResponseStatusEnum[keyof typeof ActionResponseStatusEnum];


/**
 * 
 * @export
 * @interface HitItemRequest
 */
export interface HitItemRequest {
    /**
     * 
     * @type {string}
     * @memberof HitItemRequest
     */
    'Type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof HitItemRequest
     */
    'Name'?: string | null;
}
/**
 * 
 * @export
 * @interface HitRequest
 */
export interface HitRequest {
    /**
     * 
     * @type {string}
     * @memberof HitRequest
     */
    'AccountId'?: string | null;
    /**
     * 
     * @type {PlatformType}
     * @memberof HitRequest
     */
    'Platform'?: PlatformType;
    /**
     * 
     * @type {Array<HitItemRequest>}
     * @memberof HitRequest
     */
    'Items'?: Array<HitItemRequest> | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const PlatformType = {
    HisselabWeb: 'HisselabWeb',
    HisselabMobil: 'HisselabMobil'
} as const;

export type PlatformType = typeof PlatformType[keyof typeof PlatformType];


/**
 * 
 * @export
 * @interface StringActionResponse
 */
export interface StringActionResponse {
    /**
     * 
     * @type {string}
     * @memberof StringActionResponse
     */
    'Data'?: string | null;
    /**
     * 
     * @type {ActionResponseStatusEnum}
     * @memberof StringActionResponse
     */
    'Status'?: ActionResponseStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof StringActionResponse
     */
    'Error'?: string | null;
}



/**
 * HitApi - axios parameter creator
 * @export
 */
export const HitApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {HitRequest} [hitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHitHitPost: async (identityToken: string, hitRequest?: HitRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'identityToken' is not null or undefined
            assertParamExists('apiHitHitPost', 'identityToken', identityToken)
            const localVarPath = `/api/hit/hit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (identityToken != null) {
                localVarHeaderParameter['IdentityToken'] = String(identityToken);
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(hitRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HitApi - functional programming interface
 * @export
 */
export const HitApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HitApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {HitRequest} [hitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiHitHitPost(identityToken: string, hitRequest?: HitRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<StringActionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiHitHitPost(identityToken, hitRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * HitApi - factory interface
 * @export
 */
export const HitApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HitApiFp(configuration)
    return {
        /**
         * 
         * @param {string} identityToken 
         * @param {HitRequest} [hitRequest] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiHitHitPost(identityToken: string, hitRequest?: HitRequest, options?: any): AxiosPromise<StringActionResponse> {
            return localVarFp.apiHitHitPost(identityToken, hitRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HitApi - object-oriented interface
 * @export
 * @class HitApi
 * @extends {BaseAPI}
 */
export class HitApi extends BaseAPI {
    /**
     * 
     * @param {string} identityToken 
     * @param {HitRequest} [hitRequest] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof HitApi
     */
    public apiHitHitPost(identityToken: string, hitRequest?: HitRequest, options?: AxiosRequestConfig) {
        return HitApiFp(this.configuration).apiHitHitPost(identityToken, hitRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



